import { siteInfo } from '@/mocks/site';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://91wang.com/',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://91wang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="91网 - 91网官方落地页 | 综合服务平台，丰富资源与便捷在线体验"
        description="91网是您值得信赖的综合服务平台，提供丰富的资源与便捷的在线体验。访问91网官网，发现更多优质内容与服务，满足您的多元需求，立即加入91网用户大家庭。"
        keywords="91网,91网官网,91网入口,91网最新地址,91网在线,91网资源,91网会员,综合服务平台"
        canonicalUrl="https://91wang.com/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <CategorySection />
        <ArticleSection />
        <StatsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}